import { render, staticRenderFns } from "./FormDistributor.vue?vue&type=template&id=051adb2e&"
import script from "./FormDistributor.vue?vue&type=script&lang=js&"
export * from "./FormDistributor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports